import styled from 'styled-components';
import { Table } from 'reactstrap';

export const Header = styled.div`
  justify-content: center;
  font-size: 16px;
  padding-top: 10px;
  height: 25px;
  text-align: center;
  align-items: center;
  color: #33333370;
`;

export const Content = styled.div`
  display: flex;
  font-size: 25px;
  height: 75px;
  margin-left: 5px;
  text-align: right;
  align-items: center;
  clear: both;
`;

export const Icon = styled.div`
  font-size: 25px;
  height: 30px;
  width: 30%;
  text-align: center;
  align-self: center;
`;

export const HistoryTable = styled(Table)`
  width: 100%
  margin: 0 auto;
  border-spacing: 0 10px;
  background: ${(props) => props.theme.colors.white};
  // filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  border-radius: 8px;
  padding: 30px;
  border: none;

  thead {
    border-bottom: 10px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {

    td {

      top: 0; 
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const Bloco = styled.button.attrs((props) => ({
  color: props.color,
}))`
  min-width: 200px;
  height: 113px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  margin-left: 20px auto;
  background: white;
  border-radius: 8px;
  color: #333;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  border: none;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.1));
  text-align: center;
  transition-duration: 0.2s;

  &:hover {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
  }
`;

export const Value = styled.div`
  font-size: 18px;
  font-weight: bold;
  height: 30px;
  width: 60%;
  right: 0;
`;

export const Comment = styled.div.attrs((props) => ({
  color: props.color,
}))`
  bottom: 0;
  right: 0;
  position: absolute;
  margin-bottom: 0px;
  width: 100%;
  text-align: center;
  justify-content: center;
  background: none;
  color: ${(props) => props.color};

  span {
    font-size: 13px;
  }
`;
